import React, { useState } from "react";
import TabsNav from "../../components/tabs/Tabs";

import Departments from "../../components/Settings/Admin/Departments";
import CertificateDesign from "../../components/Settings/Admin/CertificateDesign";
import WebsiteDesign from "../../components/Settings/Admin/WebsiteDesign";
import SiteAdministration from "../../components/Settings/Admin/SiteAdministration";
import { useTranslation } from "react-i18next";

const TABS = {
  WEBSITE_DESIGN: 1,
  CERTIFICATE_DESIGN: 2,
  DEPARTMENTS: 3,
  SITE_ADMINISTRATION: 4,
};

const Settings = () => {
  const [currentTab, setCurrentTab] = useState(1);
  const [isSaving, setIsSaving] = useState(false);
  const { t } = useTranslation("settings");

  const showSave =
    currentTab === TABS.WEBSITE_DESIGN || currentTab === TABS.DEPARTMENTS;

  return (
    <div className="admin-settings">
      <div className="sticky-header header-table no-padding-b admin-settings__header">
        <div className="admin-settings__toolbar d-flex align-center">
          <div className="left-side admin-settings__title">
            <h1 className="title-page mt-1 mb-0">
              {t("settings:siteSettings")}
            </h1>
          </div>

          {showSave && (
            <div className="ms-auto right-side admin-settings__actions">
              <ul className="list-filter">
                <li>
                  <button
                    type="button"
                    className="btn btn-main-color font-15"
                    onClick={() => {
                      if (!isSaving) {
                        setIsSaving(true);
                      }
                    }}
                  >
                    {t("settings:saveChanges")}
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>

        <TabsNav
          activeIndex={currentTab - 1}
          tabsConfig={[
            {
              name: "profile",
              label: t("settings:siteDesign"),
              mobileLabel: t("settings:siteDesignShort"),
              clickHandler: () => setCurrentTab(TABS.WEBSITE_DESIGN),
            },
            {
              name: "home",
              label: t("settings:certifcateDesign"),
              mobileLabel: t("settings:certifcateDesignShort"),
              clickHandler: () => setCurrentTab(TABS.CERTIFICATE_DESIGN),
            },
            {
              name: "employees",
              label: t("settings:employeesDepartments"),
              mobileLabel: t("settings:employeesDepartmentsShort"),
              clickHandler: () => setCurrentTab(TABS.DEPARTMENTS),
            },
            {
              name: "administration",
              label: t("settings:siteAdminstration"),
              mobileLabel: t("settings:siteAdminstrationShort"),
              clickHandler: () => setCurrentTab(TABS.SITE_ADMINISTRATION),
            },
          ]}
        />
      </div>

      <div className="content-page__wrapper admin-settings__body">
        <div className="tab-content" id="nav-tabContent">
          {currentTab === TABS.DEPARTMENTS && (
            <Departments submittingController={{ isSaving, setIsSaving }} />
          )}
          {currentTab === TABS.CERTIFICATE_DESIGN && <CertificateDesign />}
          {currentTab === TABS.WEBSITE_DESIGN && (
            <WebsiteDesign submittingController={{ isSaving, setIsSaving }} />
          )}
          {currentTab === TABS.SITE_ADMINISTRATION && <SiteAdministration />}
        </div>
      </div>
    </div>
  );
};

export default Settings;
